/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
export var windowLocation = windowLocation || {};
windowLocation.util = (function () {
  function setWindowLocationHRef(url) {
    window.location.href = url;
  }
  return {
    setWindowLocationHRef: setWindowLocationHRef,
  };
})();
